import { render, staticRenderFns } from "./RequestEditTabBiddersValidation.vue?vue&type=template&id=324ea9ca&scoped=true&"
import script from "./RequestEditTabBiddersValidation.vue?vue&type=script&lang=js&"
export * from "./RequestEditTabBiddersValidation.vue?vue&type=script&lang=js&"
import style0 from "./RequestEditTabBiddersValidation.vue?vue&type=style&index=0&id=324ea9ca&lang=scss&scoped=true&"
import style1 from "./RequestEditTabBiddersValidation.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324ea9ca",
  null
  
)

export default component.exports